// extracted by mini-css-extract-plugin
module.exports = {"form":"index-module--form--3fm3w","area":"index-module--area--1ExPW"};